<template>
    <div class="nk-content-wrap">
      <div class="nk-block-head nk-block-head-sm">
        <div class="nk-block-between">
          <div class="nk-block-head-content">
            <h3 class="nk-block-title page-title" v-if="ldata!=null && ldata!=undefined">{{ greetingMessage }} {{ ldata.name }}</h3>
            
          </div>
        </div>
      </div>
      <div class="nk-block">
        <div class="row g-gs">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
            <div class="card card-bordered" style="border-radius: 1rem;">
              <div class="card-inner" style="text-align: center; width:100%; padding: 1rem;">
                <div class="card-title-group align-start">
                  <div class="card-title" style="text-align: center; width:100%;">
                    <h6 class="title" style="font-size: 1rem;">Today's Payments</h6>
                  </div>
                </div>
                <div style="text-align: center; width:100%; height: 20.2rem; padding: 1rem;">
                  <div v-if="bookings.length<=0">
                    <em style="font-size: 3rem;" class="icon ni ni-calendar-booking"></em>
                    <h6>Update on Payments</h6>
                    <p> View your recent payments right here</p>
                  </div>
                  <div class="example-alert" style="margin-bottom: .4rem;"
                    v-for="(user,index) in bookings" :key="user">
                    <div class="alert alert-warning alert-icon"  style="border-radius: 1rem;" v-if="index<=2 && bookings.length>0"><em v-if="user.appointment_status === 'Pending'" class="icon ni ni-alert-circle text-warning" title="Pending"></em>
                    <em v-if="user.appointment_status === 'Completed'" class="icon ni ni-check-circle text-success" title="Completed"></em>
                    <em v-if="user.appointment_status === 'Canceled'" class="icon ni ni-cross-circle text-danger" title="Canceled"></em>

                      <strong>AMT: {{ user.appointment_amt }}</strong> &nbsp;
                      <strong>Customer: {{ user.appointment_customer_name }}</strong> <br> {{ user.appointment_date }}, {{ user.appointment_slot }}</div>
                    </div>
                </div>
                
                <a href="/booking_pages" class="btn btn-outline-success" style="width:60%; border-radius: .6rem;">
                  <span>Create Booking</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4">
            <div class="card card-bordered" style="border-radius: 1rem;">
              <div class="card-inner" style="text-align: center; width:100%; padding: 1rem;">
                <div class="card-title-group align-start">
                  <div class="card-title" style="text-align: center; width:100%;">
                    <h6 class="title" style="font-size: 1rem;">Today's Meetings</h6>
                  </div>
                </div>
                <div style="text-align: center; width:100%; height: 20.2rem; padding: 1rem;">
                  <div v-if="bookings.length<=0">
                    <em style="font-size: 3rem;" class="icon ni ni-calendar-booking"></em>
                    <h6>Update on Meetings</h6>
                  <p> View your upcoming meetings right here </p>
                  </div>
                  <div class="example-alert" style="margin-bottom: .4rem;"
                    v-for="(user,index) in bookings" :key="user">
                    <div class="alert alert-success alert-icon" style="border-radius: 1rem;" v-if="index<=2 && bookings.length>0">
                      <em v-if="user.appointment_status === 'Pending'" class="icon ni ni-alert-circle text-warning" title="Pending"></em>
                    <em v-if="user.appointment_status === 'Completed'" class="icon ni ni-check-circle text-success" title="Completed"></em>
                    <em v-if="user.appointment_status === 'Canceled'" class="icon ni ni-cross-circle text-danger" title="Canceled"></em>
                      <strong>Customer: {{ user.appointment_customer_name }}</strong> <br> 
                      {{ user.appointment_date }}, {{ user.appointment_slot }}</div>
                    </div>
                </div>
                
                <a href="/bookings" class="btn btn-outline-success" style="width:60%; border-radius: .6rem;">
                  <span>View Meetings</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
            <div class="card card-bordered" style="border-radius: 1rem;">
              <div class="card-inner" style="text-align: center; width:100%; padding: 1rem;">
                <div class="card-title-group align-start">
                  <div class="card-title" style="text-align: center; width:100%;">
                    <h6 class="title" style="font-size: 1rem;">Get Power with AI</h6>
                  </div>
                </div>
                <div style="text-align: center; width:100%; height: 20rem; padding: 1rem;">
                  <div v-if="bookings.length<=0">
                    <em style="font-size: 3rem;" class="icon ni ni-calendar-booking"></em>
                    <h6>Update on Reports!!</h6>
                    <p> View your recent AI Reports right here!</p>
                  </div>
                  <div class="example-alert" style="margin-bottom: .4rem;"
                    v-for="(user,index) in bookings" :key="user">
                    <div class="alert alert-light alert-icon" style="border-radius: 1rem; padding-left: 1.7rem; align-items: center; text-align: start;" v-if="index<=2 && bookings.length>0">
                      <div>
                        <strong>Customer: {{ user.appointment_customer_name }}</strong> 
                        <br>
                        {{ user.appointment_date }}, {{ user.appointment_slot }}
                      </div>
                      <!-- <a href="/membership" class="btn btn-sm btn-success" style="margin-left: 80%; border-radius: .6rem; margin-top: .4rem;">
                        <span>View</span>
                      </a> -->
                    </div>
                    </div>
                </div>
                
                <a href="/membership" class="btn btn-success" style="width:60%; border-radius: .6rem;">
                  <span>Start Free Trial</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card card-bordered" style="border-radius: 1rem; height:100%;" v-if="bookings.length<=0">
                <div class="card-inner" style="text-align: center; width:100%; padding: 1rem;">
                  <br>
                  <div style="text-align: center; height:15rem; width:100%; padding: 1rem; margin-top: 3rem;">
                    <em style="font-size: 5rem;" class="icon ni ni-calendar-booking"></em>
                    <br>
                    <br>
                    <h6>No upcoming bookings</h6>
                    <p> Need help? Find out more about sharing your booking pages </p>
                  </div>
                  <br>
                  <br>
                  <a href="/settings" class="btn btn-success" style="width:30%; border-radius: .6rem;">
                    <span>Upgrade To Pro</span>
                  </a>
                </div>
              </div>
              <div class="nk-block" v-if="bookings.length>0">
                <div class="card card-bordered card-stretch" style="border-radius: 1rem;">
                  <div class="card-inner-group">
                    <div class="card-inner position-relative card-tools-toggle">
                      <div class="card-title-group">
                        <div class="card-tools">
                          <div class="form-inline flex-nowrap gx-3">
                            <div class="form-wrap w-150px" style="border-radius: .6rem;">
                            <select class="form-select js-select2" v-model="appointment_status" @change="getListNow(1)" data-placeholder="Any Status" style="border-radius: .6rem;">
                              <option value="" data-select2-id="3">Any Status</option>
                              <option value="Pending">Pending</option>
                              <option value="Completed">Completed</option>
                              <option value="Canceled">Canceled</option>
                            </select>
                          </div>
                          <div class="form-wrap w-150px" style="border-radius: .6rem;">
                            <select class="form-select js-select2" v-model="appointment_mode" @change="getListNow(1)" data-placeholder="All Location" style="border-radius: .6rem;">
                              <option value="" data-select2-id="3">All Location</option>
                              <option value="Zoom Call">Zoom Call</option>
                              <option value="Google Meet">Google Meet</option>
                              <option value="In-Person Meeting">In-Person Meeting</option>
                              <option value="Phone Call">Phone Call</option>
                              <option value="Request Location">Request Location</option>
                              <option value="Custom Location">Custom Location</option>
                              <option value="No Location">No Location</option>
                            </select>
                           
                          </div>
                            <div class="btn-wrap">
                              <span class="d-md-block" style="border-radius: .6rem;">
                                <button class="btn btn-dim btn-outline-success" style="border-radius: .6rem;">Apply</button>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="card-tools me-n1">
                          <ul class="btn-toolbar gx-1">
                            <li>
                              <a href="#" class="btn btn-icon search-toggle toggle-search" data-target="search">
                                <em class="icon ni ni-search"></em>
                              </a>
                            </li>
                            <li class="btn-toolbar-sep"></li>
                          </ul>
                        </div>
                      </div>
                      <div class="card-search search-wrap" data-search="search">
                        <div class="card-body">
                          <div class="search-content">
                            <a href="#" class="search-back btn btn-icon toggle-search" data-target="search">
                              <em class="icon ni ni-arrow-left"></em>
                            </a>
                            <input type="text" class="form-control border-transparent form-focus-none" placeholder="Search by user or email">
                            <button class="search-submit btn btn-icon">
                              <em class="icon ni ni-search"></em>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-inner p-0">
                      <div class="nk-tb-list nk-tb-ulist is-compact">
                        <div class="nk-tb-item nk-tb-head">
                          <div class="nk-tb-col nk-tb-col-check">
                            <div class="custom-control custom-control-sm custom-checkbox notext">
                              <input type="checkbox" class="custom-control-input" id="uid">
                              <label class="custom-control-label" for="uid"></label>
                            </div>
                          </div>
                          <div class="nk-tb-col">
                            <span class="sub-text">Date</span>
                          </div>
                          <div class="nk-tb-col tb-col-md">
                            <span class="sub-text">Time</span>
                          </div>
                          <div class="nk-tb-col tb-col-sm">
                            <span class="sub-text">Location</span>
                          </div>
                          <div class="nk-tb-col tb-col-md">
                            <span class="sub-text">Booking made by “ Details “</span>
                          </div>
                          <div class="nk-tb-col tb-col-xxl">
                            <span class="sub-text">Meeting Destination</span>
                          </div>
                          <div class="nk-tb-col tb-col-lg">
                            <span class="sub-text">Status</span>
                          </div>
                          <div class="nk-tb-col tb-col-lg">
                            <span class="sub-text">Payment Status</span>
                          </div>
                          <div class="nk-tb-col tb-col-lg">
                            <span class="sub-text">Action</span>
                          </div>
                        </div>
                        <div class="nk-tb-item" v-for="(user,index) in bookings" :key="user">
                          <div class="nk-tb-col nk-tb-col-check">
                            <div class="custom-control custom-control-sm custom-checkbox notext">
                              <input type="checkbox" class="custom-control-input" id="uid1">
                              <label class="custom-control-label" for="uid1"></label>
                            </div>
                          </div>
                          <div class="nk-tb-col"> {{ user.appointment_date }} </div>
                          <div class="nk-tb-col tb-col-md">
                            <span>{{ user.appointment_slot }}</span>
                          </div>
                          <div class="nk-tb-col tb-col-sm">
                            <span>{{ user.appointment_customer_name }}</span>
                          </div>
                          <div class="nk-tb-col tb-col-md">
                            <span>{{ user.appointment_mode }}</span>
                          </div>
                          <div class="nk-tb-col">
                            <select class="form-select js-select2" :id="'appt_status'+index"  @change="up_st(index)" 
                            style="border-radius: .6rem;">
                              <option :value="user.appointment_status" selected>{{ user.appointment_status }}</option>
                              <option value="Pending">Pending</option>
                              <option value="Completed">Completed</option>
                              <option value="Canceled">Canceled</option>
                            </select>
                          </div>
                          <div class="nk-tb-col">
                            <select class="form-select js-select2"  :id="'appt_pay_status'+index" @change="up_pay_st(index)" style="border-radius: .6rem;">
                              <option :value="user.appointment_payment_status" selected>{{ user.appointment_payment_status }}</option>
                              <option value="Pending">Paid</option>
                              <option value="Free">Free</option>
                              <option value="Pending">Pending</option>
                            </select>
                          </div>
                          <div class="nk-tb-col nk-tb-col-tools">
                          <div class="drodown">
                                <a href="javascript:void(0)" class="btn btn-sm btn-icon btn-trigger dropdown-toggle" data-bs-toggle="dropdown">
                                  <em class="icon ni ni-more-h"></em>
                                </a>
                                <div class="dropdown-menu dropdown-menu-end">
                                  <ul class="link-list-opt no-bdr">
                                    <li>
                                      <a :href="user.appointment_meet" target="_blank" v-if="user.appointment_meet!=='none'">
                                        <em class="icon ni ni-video"></em>
                                        <span>Start Meeting</span>
                                      </a>
                                    </li>
                                    <li>
                                      <a href="javascript:void(0)" @click="appoint_view(user)">
                                        <em class="icon ni ni-calendar-check"></em>
                                        <span>View Meeting</span>
                                      </a>
                                    </li>
                                    <li class="divider"></li>
                                    <li>
                                      <a href="javascript:void(0)">
                                        <em class="icon ni ni-bell"></em>
                                        <span>Send Reminders</span>
                                      </a>
                                    </li>
                                    <li>
                                      <a href="javascript:void(0)" @click="update_st('Canceled',user.appointment_id)">
                                        <em class="icon ni ni-cross-circle"></em>
                                        <span>Cancel</span>
                                      </a>
                                    </li>
                                    <li>
                                      <a href="javascript:void(0)" @click="reche_now(user)">
                                        <em class="icon ni ni-clock"></em>
                                        <span>Reschedule</span>
                                      </a>
                                    </li>
                                  </ul>

                                </div>
                              </div>
                        </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-inner">
                      <div class="nk-block-between-md g-3">
                        <div class="g">
                          <ul class="pagination justify-content-center justify-content-md-start">
                            <li class="page-item">
                              <a class="page-link" v-if="page_no>3" @click="getListNow(page_no-3)" href="javascript:void(0)">Prev</a>
                            </li>
                            <li class="page-item">
                              <a class="page-link" v-if="page_no>2" @click="getListNow(page_no-2)" href="javascript:void(0)">{{ (page_no-2) }}</a>
                            </li>
                            <li class="page-item">
                              <a class="page-link" v-if="page_no>1" @click="getListNow(page_no-1)" href="javascript:void(0)">{{ (page_no-1) }}</a>
                            </li>
                            <li class="page-item">
                              <span class="page-link">
                                <em class="icon ni ni-more-h"></em>
                              </span>
                            </li>
                            <li class="page-item">
                              <a class="page-link" href="javascript:void(0)" @click="getListNow(page_no+1)">{{ (page_no+1) }}</a>
                            </li>
                            <li class="page-item">
                              <a class="page-link" href="javascript:void(0)" @click="getListNow(page_no+2)">{{ (page_no+2) }}</a>
                            </li>
                            <li class="page-item">
                              <a class="page-link" href="javascript:void(0)" @click="getListNow(page_no+3)">Next</a>
                            </li>
                          </ul>
                        </div>
                        <!-- <div class="g">
                          <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                            <div>Page</div>
                            <div>
                              <select class="form-select js-select2" v-model="count" @change="getListNow(1)" data-search="on" data-dropdown="xs center">
                                <option value="page-1">1</option>
                                <option value="page-2">2</option>
                                <option value="page-4">4</option>
                                <option value="page-5">5</option>
                                <option value="page-6">6</option>
                                <option value="page-7">7</option>
                                <option value="page-8">8</option>
                                <option value="page-9">9</option>
                                <option value="page-10">10</option>
                                <option value="page-11">11</option>
                                <option value="page-12">12</option>
                                <option value="page-13">13</option>
                                <option value="page-14">14</option>
                                <option value="page-15">15</option>
                                <option value="page-16">16</option>
                                <option value="page-17">17</option>
                                <option value="page-18">18</option>
                                <option value="page-19">19</option>
                                <option value="page-20">20</option>
                              </select>
                            </div>
                            <div>OF {{ totalRecords }}</div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="col-lg-4">
            <div class="card card-bordered" style="border-radius: 1rem;">
              <div class="card-inner" style="padding: 1rem;">
                <h6 class="card-title">Ready to Accept Payments</h6>
                <p class="card-text">Connect your favorite payment gateway and start accepting payments.</p>
                <a href="/settings" class="btn btn-primary" style="background-color: #003087; border-color: #003087; border-radius: .5rem;">
                  <i class="fa-brands fa-paypal" style="font-size: 1rem; color: #fff;"></i> &nbsp;&nbsp; <span>Paypal</span>
                </a> &nbsp; <a href="/settings" class="btn btn-primary" style="background-color: #635bff; border-color: #635bff; border-radius: .5rem;">
                  <i class="fa-brands fa-cc-mastercard" style="font-size: 1rem; color: #fff;"></i> &nbsp;&nbsp; <span>Netivia</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card card-bordered" style="border-radius: 1rem;">
              <div class="card-inner" style="padding: 1rem;">
                <h6 class="card-title">Ready to Connect Your Calendar?</h6>
                <p class="card-text">Seamlessly sync your calendar to manage appointments effortlessly.</p>
                <a href="/settings" class="btn btn-outline-success" style="border-radius: .5rem;"> &nbsp;&nbsp; <span>Connect Now</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card card-bordered" style="border-radius: 1rem;">
              <div class="card-inner" style="padding: 1rem;">
                <h6 class="card-title">Ready to connect  Meetings?</h6>
                <p class="card-text">Integrate your meeting platform to schedule and join calls with ease</p>
                <a href="/settings" class="btn btn-outline-success" style="border-radius: .5rem;"> &nbsp;&nbsp; <span>Connect Now</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import {
      mainBaseUrl
    } from '@/apis/appconst';
    import {
      getAppointmentList, upAppStatus, upAppStatus1
    } from '@/apis/appointapi';
    export default {
      name: 'AppDash',
      methods: {
        async up_pay_st(index){
          var tmp = this.bookings[index];
          const response = await upAppStatus1(tmp.appointment_id,document.getElementById("appt_pay_status"+index).value);
          if (response.status) {
            this.getListNow(1);
          }
        },
        async up_st(index){
          var tmp = this.bookings[index];
          const response = await upAppStatus(tmp.appointment_id,document.getElementById("appt_status"+index).value);
          if (response.status) {
            this.getListNow(1);
          }
        },
        async getListNow($page_no) {
          this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
          this.get_greet();
          this.page_no = $page_no;
          const response = await getAppointmentList(this.page_no, "5", this.ldata.user_id);
          if (response.status) {
            this.bookings = response.records;
            this.totalRecords = response.pagination.totalRecords;
          }
        },
        get_greet(){
          const hour = new Date().getHours();
          if (hour >= 5 && hour < 12) {
            this.greetingMessage =  "Good Morning 🌅";
          } else if (hour >= 12 && hour < 13) {
            this.greetingMessage =   "Good Noon ☀️";
          } else if (hour >= 13 && hour < 18) {
            this.greetingMessage =   "Good Afternoon 🌤";
          } else if (hour >= 18 && hour < 21) {
            this.greetingMessage =   "Good Evening 🌆";
          } else {
            this.greetingMessage =   "Good Night 🌙";
          }
        }
      },
      data() {
        return {
          base_url: "",
          bookings: [],
          greetingMessage:"",
          totalRecords: "",
          ldata: null,
          page_no: "1"
        };
      },
      created(){
        this.base_url = mainBaseUrl;
        if (sessionStorage.getItem("ldata") && sessionStorage.getItem("ldata").length > 0) {
          this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
          this.getListNow(1);
        }
      }
    }
  </script>